module.exports = __webpack_public_path__ + "img/grid_layout_1_4.7482419a.svg";